import { useCallback } from 'react';
import { ParsedUrlQueryInput } from 'querystring';
import { stringify } from 'query-string';
import { useRouter } from 'next/router';

export const useQueryParams = <Params extends ParsedUrlQueryInput>(): [
  Params,
  (params: Partial<Params>) => void,
] => {
  const router = useRouter();

  const setParams = useCallback(
    (params: Partial<Params>): Promise<boolean> | boolean => {
      if (stringify(params) === stringify(router.query)) {
        return true;
      }

      return router.replace(
        {
          query: params,
          pathname: router.pathname,
        },
        undefined,
        {
          shallow: true,
        },
      );
    },
    [router.pathname, router.query],
  );

  return [router.query as Params, setParams];
};
